import React from "react";

const Footer = ({ entity = "earnings" }) => (
  <div className="footer">
    <i>Currently inactive {entity} are not shown.</i>
  </div>
);

export default Footer;
